import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box } from "@mui/material";
import { sidemenuService } from "../../utils/services/sidemenu.service";
import CustomPagination from "../../components/pagination";
import SidemenuList from "../../components/sidemenu-list";
import SidemenuModal from "../../components/sidemenu-modal";
import { filterReducer } from "../../utils/filterConfig";
import { sidemenuFilterConfig } from "../../utils/filter-config";
import buildQuery from "../../utils/query-builder";

const Sidemenu = () => {
  const [filterData, dispatch] = useReducer(
    filterReducer,
    sidemenuFilterConfig,
  );
  console.log(filterData, "filterData");
  const [selectedSidemenu, setSelectedSidemenu] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [sidemenuList, setSidemenuList] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = React.useState(0);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const clientId = localStorage.getItem("client_id");

  const fetchSidemenus = async () => {
    setLoading(true);
    try {
      const response = await sidemenuService.fetch(
        null,
        null,
        null,
        buildQuery(filterData, page),
      );
      setSidemenuList(response.data);
      setLoading(false);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSidemenus();
  }, [page, filterData]);

  const handleEditSidemenu = (sidemenu) => {
    setSelectedSidemenu(sidemenu);
    setOpenModal(true);
  };

  const handleDeleteSidemenu = async (id) => {
    try {
      await sidemenuService.delete(id);
      fetchSidemenus(); // Refresh the list
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const handleAddData = () => {
    fetchSidemenus(); // Refresh the list
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedSidemenu(null);
  };

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  return (
    <>
      <DashboardContainer
        filterButton={false}
        hideUploadButton
        header={"Sidemenu List"}
        title={"+ Sidemenu"}
        onClickAddButton={() => setOpenModal(true)}
        setViewMode={setViewMode}
        hideFilterClient={true}
        onClickRefresh={() => fetchSidemenus()}
      >
        <SidemenuList
          data={sidemenuList}
          onEditSidemenu={handleEditSidemenu}
          onDeleteSidemenu={handleDeleteSidemenu}
          viewMode={viewMode}
          selectedSidemenu={selectedSidemenu}
          setSelectedSidemenu={setSelectedSidemenu}
          currentPage={page}
          itemsPerPage={filterData.limit}
          loading={loading}
          filterData={filterData}
          onChangeFilter={handleFilterChange}
        />
        <CustomPagination
          dataCount={dataCount}
          rowsPerPage={filterData.limit}
          page={page}
          setPage={setPage}
          setRowsPerPage={(e) =>
            dispatch({
              type: "UPDATE_LIMIT",
              payload: e,
            })
          }
          disableNext={dataCount <= (page + 1) * filterData.limit}
        />
      </DashboardContainer>

      <SidemenuModal
        open={openModal}
        handleClose={handleCloseModal}
        onAddData={handleAddData}
        selectedSidemenu={selectedSidemenu}
      />
    </>
  );
};

export default Sidemenu;
